import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePSLList } from './normalize';

export const fetchPSLList = createProvider(api.fetchPSLList)
  .andThen((res) => normalizePSLList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
